import {ParsingFunction} from '@bavary/core/lib/types/compiler/types';

export const ignore: ParsingFunction = (): boolean => true;
